import { CheckCircle2, Info, AlertTriangle, X } from 'lucide-react';
import { useToasts } from '@nw/web-platform';
import { cn } from '@nw/ui';

export function Toaster() {
  const { toasts, dismiss } = useToasts();
  return (
    <div aria-live="polite" className="pointer-events-none fixed inset-x-3 bottom-20 z-[60] flex flex-col items-center gap-2 md:bottom-6">
      {toasts.map((t) => {
        const Icon = t.tone === 'success' ? CheckCircle2 : t.tone === 'error' ? AlertTriangle : Info;
        return (
          <div
            key={t.id}
            role={t.tone === 'error' ? 'alert' : 'status'}
            className={cn('nw-dialog pointer-events-auto flex min-h-12 w-full max-w-md items-center gap-3 rounded-[var(--nw-radius-panel)] bg-[#16323B] px-4 py-2.5 text-[0.95rem] text-white shadow-[var(--nw-shadow-sheet)]')}
          >
            <Icon className={cn('size-4 shrink-0', t.tone === 'error' ? 'text-[#F5A08E]' : 'text-[#8FD0E0]')} aria-hidden />
            <span className="flex-1">{t.message}</span>
            {t.action ? (
              <button
                type="button"
                className="min-h-9 rounded px-2 font-semibold text-[#8FD0E0] hover:underline"
                onClick={() => {
                  t.action!.run();
                  dismiss(t.id);
                }}
              >
                {t.action.label}
              </button>
            ) : null}
            <button type="button" aria-label="Dismiss" className="grid size-9 place-items-center rounded-full hover:bg-white/10" onClick={() => dismiss(t.id)}>
              <X className="size-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
